import React from 'react';
import { connect } from 'react-redux';
import {
  askConfirmationUpdate,
  cancelDelete,
  deletePromo,
  hideDeleteModal,
  promoPageRequest,
  setActionUpdateName,
} from 'actions/businessLibrary/promo/promo';
import {
  ContentWrapper,
  LeftColumnWrapper,
  PageWrapper,
  RightColumnWrapper,
} from 'components/wrappers/pages';
import NoDataAndLoading from 'components/NoDataAndLoading';
import { askConfirmAction } from 'actions/confirm-action';
import { isDirty } from 'redux-form';
import { browserHistory } from 'react-router';
import { push } from 'react-router-redux';
import ConfirmActionModal from 'components/ConfirmActionModal';
import LibraryDeleteModal from 'components/LibraryDeleteModal';
import {
  libraryPromoDeleteReactivateDeactivate,
  libraryPromoStart,
} from 'clevertap/library/promo';
import { mapKeys } from 'lodash';
import DeactivateModal from './DeactivateModal';
import ReactivateModal from './ReactivateModal';
import ConfirmReactivateModal from './ConfirmReactivateModal';
import UpdateConfirmationModal from './UpdateConfirmationModal';
import DetailPromo from './DetailPromo';
import List from './List';
import ActionBar from './ActionBar';

class Promo extends React.Component {
  render() {
    const {
      openRightColumn,
      showLoadingSpinnerPage,
      promos,
      showDeleteModal,
      deletedPromo,
    } = this.props;
    return (
      <PageWrapper>
        <ActionBar />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={promos.length === 0}
              title="No Data To Display"
              description=""
              linkLabel={'Create Promo'}
              linkUrl={
                'https://mokaposhelp.zendesk.com/hc/id/articles/900000441543-Cara-Membuat-Promo'
              }
            />
            {promos.length > 0 && <List />}
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <DetailPromo />
          </RightColumnWrapper>
        </ContentWrapper>
        <ConfirmActionModal />
        <LibraryDeleteModal
          showDeleteModal={showDeleteModal}
          onHide={this._onHideModal}
          title="Promo"
          name={deletedPromo ? deletedPromo.name : ''}
          onDelete={this._onDelete}
        />
        <DeactivateModal />
        <ReactivateModal />
        <ConfirmReactivateModal />
        <UpdateConfirmationModal />
      </PageWrapper>
    );
  }

  componentDidMount() {
    libraryPromoStart();
    this.props.dispatch(promoPageRequest());
    browserHistory.listenBefore(location => {
      if (
        (this.props.isDirtyPromoTypeName ||
          this.props.isDirtyPromoConfiguration) &&
        !this.props.nextAction
      ) {
        this.props.dispatch(askConfirmAction(push(location)));
        return false;
      }
    });
  }

  _onHideModal = () => {
    this.props.dispatch(cancelDelete());
  };

  _onDelete = () => {
    const {
      deletedPromo,
      promos,
      dispatch,
      isManager,
      hashedPromoType,
      outlets,
    } = this.props;
    const hashedOutlets = mapKeys(outlets, 'id');
    const outletNames = [];
    deletedPromo.outlet_ids.forEach(oId => {
      if (hashedOutlets[oId]) {
        outletNames.push(hashedOutlets[oId].name);
      }
    });
    libraryPromoDeleteReactivateDeactivate('Promo Delete', {
      promoType: hashedPromoType[deletedPromo.promo_type_id].name,
      promoName: deletedPromo.name,
      outlet: outletNames,
    });
    if (isManager) {
      dispatch(setActionUpdateName('delete'));
      dispatch(hideDeleteModal());
      dispatch(askConfirmationUpdate(deletePromo(deletedPromo.id, promos)));
    } else {
      dispatch(deletePromo(deletedPromo.id, promos));
    }
  };
}

function mapStateToProps(state) {
  const {
    openRightColumn,
    promos,
    showDeleteModal,
    deletedPromo,
    promoTypes,
    outlets,
  } = state.businessLibrary.promo;
  const hashedPromoType = mapKeys(promoTypes, 'id');
  const { showLoadingSpinnerPage } = state.loadingSpinner;
  const { nextAction } = state.confirmAction;
  const isManager = state.moka.user.is_manager;
  return {
    openRightColumn,
    showLoadingSpinnerPage,
    isDirtyPromoTypeName: isDirty('promoTypeAndName')(state),
    isDirtyPromoConfiguration: isDirty('promoConfig')(state),
    nextAction,
    promos,
    showDeleteModal,
    deletedPromo,
    isManager,
    hashedPromoType,
    outlets,
  };
}

export default connect(mapStateToProps)(Promo);
